import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class StorageService {
  private storeDataSubjects = new Map<string, BehaviorSubject<any>>();

  init(): void {
    const skeys = Object.keys(localStorage);

    skeys.forEach((k) => {
      const data = this.isJson(localStorage[k])
        ? JSON.parse(localStorage[k])
        : null;
      if (data) {
        this.storeDataSubjects.set(k, new BehaviorSubject<any>(data));
      }
    });
  }

  watch(key: string): Observable<any> | null {
    if (!this.storeDataSubjects.has(key)) {
      this.storeDataSubjects.set(key, new BehaviorSubject<any>(null));
    }
    let item: any = localStorage.getItem(key);
    const storeDataKey = this.storeDataSubjects.get(key);
    if (item == "undefined" || !this.isJson(item)) {
      item = undefined;
    } else {
      item = JSON.parse(item);
    }

    if (storeDataKey) {
      storeDataKey.next(item);
    }
    return storeDataKey ? storeDataKey.asObservable() : null;
  }

  set(key: string, value: any): void {
    const val = JSON.stringify(value);
    localStorage.setItem(key, val);
    const storeDataKey = this.storeDataSubjects.get(key);
    if (!this.storeDataSubjects.has(key) || !storeDataKey) {
      this.storeDataSubjects.set(key, new BehaviorSubject<any>(val));
    } else {
      storeDataKey.next(value);
    }
  }

  get(key: string): any {
    const valKey: any = localStorage.getItem(key);
    return this.isJson(valKey) ? JSON.parse(valKey) : null;
  }

  remove(key: string): void {
    localStorage.removeItem(key);
    const storeDataKey = this.storeDataSubjects.get(key);
    if (!this.storeDataSubjects.has(key) || !storeDataKey) {
      this.storeDataSubjects.set(key, new BehaviorSubject<any>(null));
    } else {
      storeDataKey.next(null);
    }
  }

  getKeyList(search: string): string[] {
    const arr = Array.from(this.storeDataSubjects.keys());
    return arr.filter((x) => x.includes(search));
  }

  isJson(item) {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
      value = JSON.parse(value);
    } catch {
      return false;
    }

    return typeof value === "object" && value !== null;
  }
}
